import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    marginLeft: '0.25rem',
    flexShrink: 0
  }
}))

export default useStyles
